module.exports = __webpack_public_path__ + "img/wz-8-1-2.bc99f897.jpg";